module.exports = __webpack_public_path__ + "static/media/d9ece687.jpg";